angular.module('policyModule')
    .service('authentication', [
        '$cookies',
        '$q',
        '$window',
        'customerApi',
        'customer',
        '$rootScope',
        'configuration',
        'edxLocalStorageService',
        'dblAnalyticsProvider',
    function(
        $cookies,
        $q,
        $window,
        $customerApi,
        $customer,
        $rootScope,
        configuration,
        localStorageService,
        $analytics
    ) {

        var customer = null;
        var customerSubject = new Rx.ReplaySubject();
        var INVALID_CUST_ID = -1;

        var isLoggedIn = function() {
            return !!customer;
        };

        var isValid = function() {
            return customer.valid;
        };

        var getCustomer = function() {
            return customer;
        };

        var getCustomerSubject = function () {
            return customerSubject;
        };

        var simulateLogin = function() {
            var promises = $customerApi.getCustomer();
            promises.$httpPromise.then(function(resolvedCustomer) {
                if (resolvedCustomer.id !== INVALID_CUST_ID) {
                    customer = resolvedCustomer;
                    customer.valid = true;

                    if (isGuardian(customer)) {
                        var astFromCookie = loadAstFromCookie();
                        if (astFromCookie.academic_standard_name && astFromCookie.academic_standard_title_in_reports) {
                            _.extend(customer, astFromCookie);
                        }
                    } else {
                        var astFromSession = loadAstFromSession();
                        if (astFromSession.academic_standard_name && astFromSession.academic_standard_title_in_reports) {
                            _.extend(customer, astFromSession);
                        }
                    }

                    customerSubject.onNext(customer);
                    $rootScope.$emit('customerInfoSet', customer);
                } else {
                    // Still need to assign the customer or we'll get stuck in an loop.
                    customer = resolvedCustomer;
                    customer.valid = false;
                }
            });
            return promises.$httpPromise;
        };

        var validatePolicy = function(params, stateName) {
            //var leftPaneName = params.edit ? 'edit' : 'show';
            var leftPaneName;

            if (params.edit) {
                leftPaneName = 'edit';
            } else if (params.assign) {
                leftPaneName = 'assign';
            } else {
                leftPaneName = 'show';
            }

            var rightPaneName = params.pane;

            if (isLoggedIn()) {
                var policy = customer.policy[stateName];
                var leftPanePolicy = policy[leftPaneName];
                var rightPanePolicy = rightPaneName ? policy[rightPaneName] : false;
                return (leftPanePolicy && rightPanePolicy);
            } else {
                return false;
            }
        };

        var getCustomerDefaultUrl = function () {
          var url = '';

          if (useBts2020Nav()) {
            /**
             * Admins with classrooms no not have classroom ids
             * (issue in product :
             *   https://www.flowdock.com/app/dreambox/tonic-ai-poc/threads/KOKqhkQ0TN7NURBntqiGlbxAhGz
             * )
             * and will redirect to reports, which is somewhat inline with edex today,
             * which directs admins to district / school level instead of their teacher level home.
             * Fixing this using classroom api causes circular dependency, suggest fixing this maybe when we
             * port nav bar from angularjs to angular
             */
            if (customer.hasClassrooms()) {
              url = 'home';
            } else if (isDistrictAdmin(customer) || isSchoolAdmin(customer)) {
              url = 'reports';
            } else {
              url = 'missingroster';
            }
          } else {
            url += '/district/' + customer.district_id;
            if (isDistrictAdmin(customer)) {
                url += '?breadcrumbs=d';
            }
            if (isSchoolAdmin(customer)) {
                url += '/school/' + customer.school_id;
                url += '?breadcrumbs=d,sc';
            }
            if (isTeacher(customer)) {
                if (customer.classroom_ids && customer.classroom_ids.length === 1) {
                    url += '/classroom/' + customer.classroom_ids[0];
                    url += '?breadcrumbs=d,sc,t,c&teacherId=' + customer.id + '&schoolId=' + customer.school_id;
                } else {
                    url += '/teacher/' + customer.id;
                    url += '?breadcrumbs=d,sc,t&schoolId=' + customer.school_id;
                }
            }
            if (isGuardian(customer)) {
                url += '/guardian/' + customer.id;
                url += '?breadcrumbs=g';
            }
          }

          return url;
        };

        var ensureLogin = function () {
            var loginDeferred = $q.defer();

            if (!isLoggedIn()) {
                simulateLogin().then(function() {
                    on_signin(); // hook right after signin

                    loginDeferred.resolve(customer);
                }, function (reason) {
                    return $q.reject(reason);
                });
            } else {
                 loginDeferred.resolve(customer);
            }

            return loginDeferred.promise;
        };

        var on_signin = function() {
           $rootScope.$broadcast('login');
        };

        var isAdmin = function (localCustomer) {
            return isDistrictAdmin(localCustomer) || isSchoolAdmin(localCustomer);
        };

        var isDistrictAdmin = function(localCustomer) {
            return localCustomer.role === 'districtAdmin';
        };

        var isSchoolAdmin = function(localCustomer) {
            return localCustomer.role === 'schoolAdmin';
        };

        var isTeacher = function(localCustomer) {
            return localCustomer.role === 'teacher';
        };

        var isGuardian = function(localCustomer) {
            return localCustomer.role === 'guardian';
        };

        var getCustomerInvalidTypes = function() {
            if (isDistrictAdmin(customer)) {
                return [];
            }
            if (isSchoolAdmin(customer)) {
                return ['school'];
            }
            if (isTeacher(customer)) {
                return ['school', 'grade', 'teacher'];
            }
            if (isGuardian(customer)) {
              return ['school', 'grade', 'teacher', 'classroom'];
            }
            return [];
        };

        var isEditLocked = function(localCustomer) {
          var bReturn = false;
          if (typeof localCustomer !== 'undefined' && localCustomer !== null && localCustomer.edit_locked === true) {
            bReturn = true;
          }
          return bReturn;
        };

        var isMagnetoManaged = function(localCustomer) {
          var bReturn = false;
          if (typeof localCustomer !== 'undefined' && localCustomer !== null &&
              typeof localCustomer.district_provision_uid !== 'undefined' &&
              typeof localCustomer.provision_uid !== 'undefined') {
            bReturn = true;
          }
          return bReturn;
        };

        var canAssignLessons = function(localCustomer) {
            var bReturn = false;
            if (typeof localCustomer !== 'undefined' && localCustomer !== null && localCustomer.assign_focus_enabled === true) {
                bReturn = true;
            }
            return bReturn;
        };

        var canViewConceptsMap = function(localCustomer) {
            return hasTag(localCustomer, 'CONCEPTSMAP_PREVIEW_ENABLED');
        };

        var hasTag = function(localCustomer, tag) {
           return typeof localCustomer !== 'undefined' && localCustomer !== null && localCustomer.hasTag(tag);
        };

        var getMagnetoOption = function(localCustomer, magnetoOption) {
            if(!localCustomer || !localCustomer.magneto_district_options) {
                return null;
            }
            return localCustomer.magneto_district_options[magnetoOption];
        };

        var isSsoLoginOnly = function(localCustomer) {
          /*
           * When ssoOnly == undefined, then we have district options but the option isn't specified so we default to false
           * When ssoOnly == null, then that means we can't get the district options for whatever reason (failure to
           * communicate with Magneto most likely) and we assume the most restrictive option, which is true.
           */
          var ssoOnly = getMagnetoOption(localCustomer, 'login.ssoOnly');
          return ssoOnly === 'true' || ssoOnly === null;
        };

        var educatorHasRosteringAccess = function (localCustomer) {
          return (isTeacher(localCustomer) && getMagnetoOption(localCustomer, 'provision.teacherRosteringAccess') === 'true') ||
            (isSchoolAdmin(localCustomer) && getMagnetoOption(localCustomer, 'provision.schoolAdminRosteringAccess') === 'true') ||
            (isDistrictAdmin(localCustomer) && getMagnetoOption(localCustomer, 'provision.districtAdminRosteringAccess') === 'true');
        };

        var growthAsFraction = function(localCustomer) {
            var bReturn = false;

            if(!localCustomer) {
                localCustomer = getCustomer();
            }

            if (typeof localCustomer !== 'undefined' && localCustomer !== null && !localCustomer.growth_as_percentage) {
                bReturn = true;
            }
            return bReturn;
        };

        var loadAstFromSession = function () {
            return {
                academic_standard_name: sessionStorage.getItem('ast_code'),
                academic_standard_title_in_reports: sessionStorage.getItem('ast')
            };
        };

        var loadAstFromCookie = function () {
            return {
                academic_standard_name: localStorageService.getItem('astName'),
                academic_standard_title_in_reports: localStorageService.getItem('astTitle')
            };
        };

        var saveAstToCookie = function (astName, astTitle) {
          localStorageService.setItem('astName', astName);
          localStorageService.setItem('astTitle', astTitle);
        };

        var useBts2020Nav = function () {
          return !isGuardian(customer);
        };

        return {
            getCustomer: getCustomer,
            getCustomerSubject: getCustomerSubject,
            isLoggedIn: isLoggedIn,
            isValid: isValid,
            simulateLogin: simulateLogin,
            validatePolicy: validatePolicy,
            ensureLogin: ensureLogin,
            getCustomerDefaultUrl: getCustomerDefaultUrl,
            isAdmin: isAdmin,
            isDistrictAdmin: isDistrictAdmin,
            isSchoolAdmin: isSchoolAdmin,
            isTeacher: isTeacher,
            isGuardian: isGuardian,
            getCustomerInvalidTypes: getCustomerInvalidTypes,
            isEditLocked : isEditLocked,
            isMagnetoManaged : isMagnetoManaged,
            canAssignLessons : canAssignLessons,
            canViewConceptsMap: canViewConceptsMap,
            growthAsFraction: growthAsFraction,
            saveAstToCookie: saveAstToCookie,
            isSsoLoginOnly: isSsoLoginOnly,
            educatorHasRosteringAccess:educatorHasRosteringAccess,
            useBts2020Nav: useBts2020Nav,
        };

    }]);
